 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc":"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc","address":"address","bank-accounts":"bank-accounts","bills":"bills","certificates~commissions~customers~overview~plan-proposal~prospects":"certificates~commissions~customers~overview~plan-proposal~prospects","certificates":"certificates","commissions~overview":"commissions~overview","commissions":"commissions","overview":"overview","customers~plan-proposal":"customers~plan-proposal","categories~customers":"categories~customers","customers":"customers","plan-proposal":"plan-proposal","prospects":"prospects","contacts":"contacts","contents":"contents","emails":"emails","files":"files","integrations":"integrations","landing-pages":"landing-pages","mails":"mails","modules":"modules","roles":"roles","users":"users","categories":"categories","colors":"colors","forget-password":"forget-password","help-center":"help-center","loading":"loading","login":"login","reseller":"reseller","reset-password":"reset-password"}[chunkId]||chunkId) + "." + {"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc":"8ccc6f0f","address":"fca7a5b0","bank-accounts":"5843dfbe","bills":"26ae8fc6","certificates~commissions~customers~overview~plan-proposal~prospects":"5277ba9d","certificates":"8cb6cc51","commissions~overview":"a1223677","commissions":"1752feb2","overview":"ac8d8a03","customers~plan-proposal":"8d2598b1","categories~customers":"93271e3f","customers":"4c69eca2","plan-proposal":"eed2db98","prospects":"c0238101","chunk-d3d32b4a":"d42458a6","contacts":"04d801ec","contents":"230486cc","emails":"ae94bd60","files":"98fe9ddc","integrations":"2819f60c","landing-pages":"8a42c423","mails":"6b747f66","modules":"72f145a2","roles":"0996bcda","users":"69a08a1d","categories":"d115938d","chunk-2d0aba49":"214a3dad","colors":"06379e60","forget-password":"d1abfaec","help-center":"72122f67","loading":"1c6a5cae","login":"7590f119","reseller":"6f0000c3","reset-password":"0c93b875","chunk-2d21aef5":"c566b1eb","chunk-e96115ce":"76e45e90","chunk-2d20f1a7":"6bbf07a0","chunk-2d21ef74":"6fdffcfb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"overview":1,"customers":1,"integrations":1,"categories":1,"help-center":1,"chunk-e96115ce":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc":"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc","address":"address","bank-accounts":"bank-accounts","bills":"bills","certificates~commissions~customers~overview~plan-proposal~prospects":"certificates~commissions~customers~overview~plan-proposal~prospects","certificates":"certificates","commissions~overview":"commissions~overview","commissions":"commissions","overview":"overview","customers~plan-proposal":"customers~plan-proposal","categories~customers":"categories~customers","customers":"customers","plan-proposal":"plan-proposal","prospects":"prospects","contacts":"contacts","contents":"contents","emails":"emails","files":"files","integrations":"integrations","landing-pages":"landing-pages","mails":"mails","modules":"modules","roles":"roles","users":"users","categories":"categories","colors":"colors","forget-password":"forget-password","help-center":"help-center","loading":"loading","login":"login","reseller":"reseller","reset-password":"reset-password"}[chunkId]||chunkId) + "." + {"address~bank-accounts~bills~certificates~commissions~contacts~contents~customers~emails~files~integr~9b8342cc":"31d6cfe0","address":"31d6cfe0","bank-accounts":"31d6cfe0","bills":"31d6cfe0","certificates~commissions~customers~overview~plan-proposal~prospects":"31d6cfe0","certificates":"31d6cfe0","commissions~overview":"31d6cfe0","commissions":"31d6cfe0","overview":"650c62d2","customers~plan-proposal":"31d6cfe0","categories~customers":"31d6cfe0","customers":"97f356a5","plan-proposal":"31d6cfe0","prospects":"31d6cfe0","chunk-d3d32b4a":"31d6cfe0","contacts":"31d6cfe0","contents":"31d6cfe0","emails":"31d6cfe0","files":"31d6cfe0","integrations":"f44a0cbd","landing-pages":"31d6cfe0","mails":"31d6cfe0","modules":"31d6cfe0","roles":"31d6cfe0","users":"31d6cfe0","categories":"417ae19f","chunk-2d0aba49":"31d6cfe0","colors":"31d6cfe0","forget-password":"31d6cfe0","help-center":"791a62a9","loading":"31d6cfe0","login":"31d6cfe0","reseller":"31d6cfe0","reset-password":"31d6cfe0","chunk-2d21aef5":"31d6cfe0","chunk-e96115ce":"1bd21d6f","chunk-2d20f1a7":"31d6cfe0","chunk-2d21ef74":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
